import { render, staticRenderFns } from "./PackagingMaterialManagement.vue?vue&type=template&id=1fd8c572"
import script from "./PackagingMaterialManagement.vue?vue&type=script&lang=js"
export * from "./PackagingMaterialManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports